<template>
  <div>
    <Breadcrumb></Breadcrumb>
    <div class="notice">
    <h2 class="text-align-center">{{ form.noticeTitle }}</h2>
    <el-divider></el-divider>
    <el-row :gutter="24" class="text-align-center" justify="center">
      <el-col :span="6" offset="6">
        公告类型: {{ dictMap['notice_type'][form.noticeType] }}
      </el-col>
      <el-col :span="6"> 发布时间: {{ form.createTime }} </el-col>
      <el-col :span="6"></el-col>
    </el-row>
    <el-row :gutter="24" justify="center">
      <el-col v-html="form.content"> </el-col>
    </el-row>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/common/Breadcrumb'
import { getNoticeInfo } from '@/api/sysSupport/notice'

export default {
  name: 'Notice',
  components: { Breadcrumb },
  data() {
    return {
      form: {},
    }
  },
  computed: {
    ...mapGetters(['dictData', 'dictMap']),
  },
  created() {
    this.loadData()
  },
  methods: {
    loadData() {
      getNoticeInfo({ noticeId: this.$route.query.noticeId }).then(
        (response) => {
          this.form = response.data
        }
      )
    },
    goBack() {
      this.$router.go(-1)
    },
  },
}
</script>
<style lang="scss" scoped>
.text-align-center {
  text-align: center;
}
.notice {
  background: #ffffff;
  padding: 32px 16px 32px 16px;
  margin: 8px 0 0 0;
}
</style>
